import React, { createRef, use } from 'react';
import ErrorHandler from '../../class/ErrorHandler';
import '../../assets/css/login.scss';
import commonMethod from '../../lib/commonMethod';
import * as requestLib from '../../lib/requestLib';
import Logo from '../../assets/img/logo_front.svg';
import eye_close from '../../assets/img/login/eye_close.svg';
import eye_open from '../../assets/img/login/eye_open.svg';
import WOW from 'wowjs';
import '../../assets/css/animate.css';
import constants from '../../lib/constants/constants';
import cookie from 'react-cookies';
const queryString = require('query-string');

const ERROR_MESSAGES = {
  EXPIRED_AUTH_CODE: '만료된 코드입니다.',
  INVALID_AUTH_CODE: '유효하지 않은 코드입니다.',
  ALREADY_SENT_CODE: '이미 인증코드가 전송되었습니다.',
  ALREADY_SUCCESS_CODE: '이미 성공한 인증코드입니다.',
  EXPIRED_SUCCESS_CODE: '만료된 코드입니다.',
  INVALID_SUCCESS_CODE: '유효하지 않은 코드입니다.'
};

const VERIFY_STATUS = {
  BEFORE: 1,
  VERIFYING: 2,
  EXPIRED: 3,
  COMPLETE: 4
};

const PHONE_NUMBER_REGEX = /\d{8,}$/;
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const EXPIRE_TIME = 3 * 60;

const DEFAULT_ERROR_MESSAGE = '아이디 / 비밀번호 불일치';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      verifyCode: '',
      password: '',
      verifyStatus: VERIFY_STATUS.BEFORE,
      remainingTime: EXPIRE_TIME,
      isCompleteVerify: false,
      autoLogin: false,
      viewPassword: false,
      errorMessage: DEFAULT_ERROR_MESSAGE,
      hoverEye: false,
      viewTooltip: false,
      error: false,
      focusUsername: false,
      focusPassword: false
    };
    this.errorHandler = new ErrorHandler(this);
    this.baseUrl = requestLib.getUrl();
    this.timerId = null;

    this.codeInputRef = createRef();
  }

  componentDidMount() {
    const wow = new WOW.WOW();
    wow.init();
    if (localStorage.getItem('accessToken')) {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      cookie.save('accessToken', accessToken.value, { path: '/' });
      window.location.href = constants.URL.LIST;
    } else if (cookie.load('accessToken') && cookie.load('autoLogin') === true)
      window.location.href = '/list';
  }

  handleAutoLogin() {
    this.setState({ autoLogin: !this.state.autoLogin });
  }

  handleKeyPress(e) {
    // enter 이벤트로 로그인
    if (e.key === 'Enter') {
      const { username, password, verifyCode, verifyStatus, error } =
        this.state;

      if (
        verifyStatus === VERIFY_STATUS.BEFORE ||
        verifyStatus === VERIFY_STATUS.EXPIRED
      ) {
        if (username.length > 0) this.handleSendCode();
      }

      const isFilledFields =
        username.length > 0 && password.length > 0 && verifyCode.length > 0;

      if (isFilledFields && verifyStatus === VERIFY_STATUS.COMPLETE && !error)
        this.submitLogin();
    }
  }

  handleKeyPressVerifyCode(e) {
    if (e.key === 'Enter') {
      const { verifyCode } = this.state;

      if (verifyCode.length === 6) this.handleVerifyCode();
    }
  }

  handleSendCode() {
    const { username } = this.state;

    const verifyStep = () => {
      this.setState({
        verifyStatus: VERIFY_STATUS.VERIFYING
      });

      const endTime = Date.now() + EXPIRE_TIME * 1000;
      this.setState({ remainingTime: EXPIRE_TIME });

      this.timerId = setInterval(() => {
        const now = Date.now();
        const diffSeconds = Math.ceil((endTime - now) / 1000);

        if (diffSeconds <= 0) {
          clearInterval(this.timerId);
          this.setState({ remainingTime: 0 });
          this.setState({ verifyStatus: VERIFY_STATUS.EXPIRED });
        } else {
          this.setState({ remainingTime: diffSeconds });
        }
      }, 1000);

      setTimeout(() => {
        this.codeInputRef.current.focus();
      }, 300);
    };

    const isPhoneNumber = PHONE_NUMBER_REGEX.test(username);

    if (isPhoneNumber) {
      commonMethod.request2FAPost(
        'api/2factor/send/sms?vendor=web',
        JSON.stringify({
          phoneNumber: username
        }),
        () => verifyStep(),
        (request, status, data) => {
          const errorCode = JSON.parse(request.responseText)?.code || '';
          const errorMessage = Object.keys(ERROR_MESSAGES).includes(errorCode)
            ? ERROR_MESSAGES[errorCode]
            : '휴대폰 번호를 확인해주세요.';
          this.setState({
            error: true,
            errorMessage
          });
        }
      );
    } else if (EMAIL_REGEX.test(username)) {
      commonMethod.request2FAPost(
        'api/2factor/send/email?vendor=web',
        JSON.stringify({
          email: username
        }),
        () => verifyStep(),
        (request, status, data) => {
          const errorCode = JSON.parse(request.responseText)?.code || '';
          const errorMessage = Object.keys(ERROR_MESSAGES).includes(errorCode)
            ? ERROR_MESSAGES[errorCode]
            : '이메일을 확인해주세요.';
          this.setState({
            error: true,
            errorMessage
          });
        }
      );
    } else {
      this.setState({
        error: true,
        errorMessage: '계정을 확인해주세요.'
      });
    }
  }

  handleVerifyCode() {
    const { username, verifyCode, verifyStatus } = this.state;

    if (verifyStatus !== VERIFY_STATUS.VERIFYING) return;

    const verifyCompleteCallback = () => {
      this.setState({
        verifyStatus: VERIFY_STATUS.COMPLETE
      });
    };

    commonMethod.request2FAPost(
      'api/2factor/verify',
      JSON.stringify({
        username,
        authCode: verifyCode
      }),
      () => verifyCompleteCallback(),
      (request, status, data) => {
        const errorCode = JSON.parse(request.responseText)?.code || '';
        const errorMessage = Object.keys(ERROR_MESSAGES).includes(errorCode)
          ? ERROR_MESSAGES[errorCode]
          : '인증번호를 확인해주세요.';
        this.setState({
          error: true,
          errorMessage
        });
      }
    );
  }

  submitLogin() {
    // 로그인 호출
    // let url = window.location.href;
    const loginData = {
      username: this.state.username,
      password: this.state.password
    };
    // API 호출 전에 쿠키 reset
    cookie.remove('demo', { path: '/' });
    cookie.remove('scene-id', { path: '/' });
    cookie.remove('accessToken', { path: '/' });
    cookie.remove('username', { path: '/' });
    cookie.remove('autoLogin', { path: '/' });
    cookie.remove('familyId', { path: '/' });
    cookie.remove('isCloseNavi', { path: '/' });
    cookie.remove('refreshTerm', { path: '/' });
    cookie.save('username', this.state.username, { path: '/' });
    localStorage.setItem('username', this.state.username);

    commonMethod.requestLogin(
      'oauth/login?vendor=shop',
      loginData,
      () => {
        const oauthData = {
          response_type: 'code',
          client_id: '62f4020744ca4510827d3b4a4d2c7e7f',
          scope: 'shop',
          redirect_uri: window.location.origin + '/list'
        };
        if (this.state.autoLogin) cookie.save('autoLogin', true, { path: '/' });
        window.location.href =
          'https://square.hej.so/oauth/authorize?' +
          queryString.stringify(oauthData);
      },
      () => this.setState({ error: true, errorMessage: DEFAULT_ERROR_MESSAGE })
    );
  }

  componentWillUnmount() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }

  render() {
    try {
      const minutes = Math.floor(this.state.remainingTime / 60);
      const seconds = this.state.remainingTime % 60;

      return (
        <div id="login">
          <div
            className="right table wow fadeInDown"
            data-wow-duration=".5s"
            data-wow-delay="1.4s"
          >
            <div className="middle">
              <div className="id-wrap">
                <input
                  type="text"
                  disabled={this.state.verifyStatus === VERIFY_STATUS.COMPLETE}
                  value={this.state.username}
                  onChange={e =>
                    // eslint-disable-next-line
                    this.setState({
                      username: e.target.value.replace(
                        /[^A-Za-z_0-9-!.,`@#$%^*_|~&()+=-]/g,
                        ''
                      ),
                      error: false
                    })
                  }
                  onKeyPress={e => this.handleKeyPress(e)}
                  placeholder="전화번호 or 이메일"
                />
                <div className="verify-section">
                  {this.state.verifyStatus !== VERIFY_STATUS.VERIFYING && (
                    <button
                      type="button"
                      className="action"
                      disabled={
                        this.state.verifyStatus === VERIFY_STATUS.COMPLETE
                      }
                      onClick={() => this.handleSendCode()}
                    >
                      인증번호 전송
                    </button>
                  )}
                  {this.state.verifyStatus === VERIFY_STATUS.VERIFYING && (
                    <span className="action">
                      {minutes.toString().padStart(2, '0')}:
                      {seconds.toString().padStart(2, '0')}
                    </span>
                  )}
                </div>
              </div>
              <div className="id-wrap">
                <input
                  ref={this.codeInputRef}
                  type="text"
                  disabled={this.state.verifyStatus !== VERIFY_STATUS.VERIFYING}
                  value={this.state.verifyCode}
                  onChange={e =>
                    // eslint-disable-next-line
                    this.setState({
                      verifyCode: e.target.value.replace(
                        /[^A-Za-z_0-9-!.,`@#$%^*_|~&()+=-]/g,
                        ''
                      ),
                      error: false
                    })
                  }
                  onKeyPress={e => this.handleKeyPressVerifyCode(e)}
                  placeholder="6자리 인증번호 입력"
                />
                <div className="verify-section">
                  <button
                    type="button"
                    className="action"
                    disabled={
                      this.state.verifyStatus !== VERIFY_STATUS.VERIFYING
                    }
                    onClick={() => this.handleVerifyCode()}
                  >
                    확인
                  </button>
                </div>
              </div>
              <div className="password-wrap">
                <input
                  type={this.state.viewPassword ? 'text' : 'password'}
                  value={this.state.password}
                  onChange={e =>
                    // eslint-disable-next-line
                    this.setState({
                      password: e.target.value.replace(
                        /[^A-Za-z_0-9-!.,`@#$%^*_|~&()+=-]/g,
                        ''
                      ),
                      error: false
                    })
                  }
                  onKeyPress={e => this.handleKeyPress(e)}
                  placeholder="비밀번호"
                />
                <img
                  src={
                    this.state.viewPassword || this.state.hoverEye
                      ? eye_open
                      : eye_close
                  }
                  onClick={() =>
                    this.setState({ viewPassword: !this.state.viewPassword })
                  }
                  onMouseOver={() => this.setState({ hoverEye: true })}
                  onMouseLeave={() => this.setState({ hoverEye: false })}
                  alt="toggle password show"
                />
              </div>
              <div className="checkbox-wrap">
                <input
                  type="checkbox"
                  checked={this.state.autoLogin}
                  onChange={() => this.handleAutoLogin()}
                  id="auto-login"
                />
                <label
                  htmlFor="auto-login"
                  onMouseOver={() => this.setState({ viewTooltip: true })}
                  onMouseLeave={() => this.setState({ viewTooltip: false })}
                >
                  자동 로그인
                </label>
                <p
                  className={
                    this.state.viewTooltip
                      ? 'auto-tooltip active'
                      : 'auto-tooltip'
                  }
                >
                  개인 컴퓨터가 아닌 경우, 보안상 자동 로그인을 권장하지
                  않습니다.
                </p>
                {this.state.error && (
                  <p className="error-text">{this.state.errorMessage}</p>
                )}
              </div>
              <button
                onClick={() => this.submitLogin()}
                className={
                  this.state.username.length > 0 &&
                  this.state.password.length > 0 &&
                  this.state.verifyStatus === VERIFY_STATUS.COMPLETE &&
                  !this.state.error
                    ? 'btn active'
                    : 'btn'
                }
                disabled={
                  this.state.username.length < 1 ||
                  this.state.password.length < 1 ||
                  this.state.verifyStatus !== VERIFY_STATUS.COMPLETE ||
                  this.state.error
                }
              >
                로그인
              </button>
              <div className="terms">
                <p>
                  * 본 서비스는 헤이홈 앱 서비스를 기반으로 제공되며,{' '}
                  <a href="https://hej.life/member/agreement.html">
                    서비스이용약관
                  </a>{' '}
                  및{' '}
                  <a href="https://hej.life/member/privacy.html">
                    개인정보보호정책
                  </a>
                  은 기존 약관이 적용됩니다.
                </p>
              </div>
            </div>
          </div>
          <div
            className="left table wow slideInLeft"
            data-wow-duration="1s"
            data-wow-delay="0s"
          >
            <div className="middle">
              <div
                className="wow fadeInLeft"
                data-wow-duration=".3s"
                data-wow-delay="1s"
              >
                <img src={Logo} className="logo" alt="" />
                <p>
                  회원가입은 앱스토어나 플레이스토어에서 &quot;헤이홈&quot;
                  어플을 다운 받아 가능합니다.
                  <br />
                  헤이홈 for Web은 구글 크롬 브라우저 전용 서비스입니다.
                </p>
                <button
                  onClick={() => {
                    window.location.href = constants.URL.DEMOLIST;
                  }}
                  className="btn_demo"
                >
                  데모 버전 체험 하기 &gt;
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    } catch (error) {
      this.errorHandler.processError(error);
      return null;
    }
  }
}

export default Login;
